import type { UiNode, UiNodeTextAttributes, UiText } from "@ory/kratos-client";

interface Props {
	node: UiNode;
	attributes: UiNodeTextAttributes;
}

const Content = ({ attributes }: Props) => {
	switch (attributes.text.id) {
		case 1050015: {
			// This text node contains lookup secrets. Let's make them a bit more beautiful!
			const secrets = (attributes.text.context as { secrets: UiText[] }).secrets
				// crypto.randomUUID() replaces nanoid(4); stable index keys are disallowed by biome noArrayIndexKey
				.map((text: UiText) => (
					<div
						key={crypto.randomUUID()}
						data-testid={`node/text/${attributes.id}/lookup_secret`}
						className="col-xs-3"
					>
						{/* Used lookup_secret has ID 1050014 */}
						<code>{text.id === 1050014 ? "Used" : text.text}</code>
					</div>
				));
			return (
				<div
					className="container-fluid mt-6"
					data-testid={`node/text/${attributes.id}/text`}
				>
					<div className="row">{secrets}</div>
				</div>
			);
		}
	}

	return (
		<div data-testid={`node/text/${attributes.id}/text`}>
			<code>{attributes.text.text}</code>
		</div>
	);
};

export const NodeText = ({ node, attributes }: Props) => {
	return (
		<>
			<p data-testid={`node/text/${attributes.id}/label`} className="mt-6">
				{node.meta?.label?.text}
			</p>
			<Content node={node} attributes={attributes} />
		</>
	);
};
